const redirectToKYC = (id,url) => {
    document.getElementById(id).setAttribute("disabled", true);
    if (url) {
        window.location.href = url;
    }
};

export default redirectToKYC;